import { render, staticRenderFns } from "./terminalBox.vue?vue&type=template&id=38cbab16&scoped=true"
import script from "./terminalBox.vue?vue&type=script&lang=js"
export * from "./terminalBox.vue?vue&type=script&lang=js"
import style0 from "./terminalBox.vue?vue&type=style&index=0&id=38cbab16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cbab16",
  null
  
)

export default component.exports